/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {ReleaseNote} from '../models/ReleaseNote';
import type {ReleaseNoteInfo} from '../models/ReleaseNoteInfo';

export interface DeleteReleaseNote$Request {
    releaseNoteId: number;
}

export interface DeleteReleaseNote$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const deleteReleaseNoteRequest = createAction<PayloadData<void, DeleteReleaseNote$Request>>('RELEASE_NOTES_CONTROLLER__DELETE_RELEASE_NOTE__REQUEST');
export const deleteReleaseNoteSuccess = createAction<PayloadData<void, DeleteReleaseNote$Request>>('RELEASE_NOTES_CONTROLLER__DELETE_RELEASE_NOTE__SUCCESS');
export const deleteReleaseNoteFailure = createAction<PayloadData<Error, DeleteReleaseNote$Request, true>>('RELEASE_NOTES_CONTROLLER__DELETE_RELEASE_NOTE__FAILURE');

export const deleteReleaseNoteActions = [
    deleteReleaseNoteRequest,
    deleteReleaseNoteSuccess,
    deleteReleaseNoteFailure
] as const;

/**
 * Delete Release Note
 * @param {number} meta.releaseNoteId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const deleteReleaseNote = (meta: DeleteReleaseNote$Request, config?: DeleteReleaseNote$Config) => {
    const TRANSPORT_GET_PARAMS = {
        releaseNoteId: meta.releaseNoteId,
    };
    return {
        CALL_API: {
            types: deleteReleaseNoteActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/api-v2/release-notes`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetReleaseNotes$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getReleaseNotesRequest = createAction<PayloadData<void>>('RELEASE_NOTES_CONTROLLER__GET_RELEASE_NOTES__REQUEST');
export const getReleaseNotesSuccess = createAction<PayloadData<ReleaseNoteInfo>>('RELEASE_NOTES_CONTROLLER__GET_RELEASE_NOTES__SUCCESS');
export const getReleaseNotesFailure = createAction<PayloadData<Error, void, true>>('RELEASE_NOTES_CONTROLLER__GET_RELEASE_NOTES__FAILURE');

export const getReleaseNotesActions = [
    getReleaseNotesRequest,
    getReleaseNotesSuccess,
    getReleaseNotesFailure
] as const;

/**
 * All Release Notes
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getReleaseNotes = (config?: GetReleaseNotes$Config) => {
    return {
        CALL_API: {
            types: getReleaseNotesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/api-v2/release-notes`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface SaveReleaseNote$Request {
    releaseNote: ReleaseNote;
}

export interface SaveReleaseNote$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveReleaseNoteRequest = createAction<PayloadData<void, SaveReleaseNote$Request>>('RELEASE_NOTES_CONTROLLER__SAVE_RELEASE_NOTE__REQUEST');
export const saveReleaseNoteSuccess = createAction<PayloadData<ReleaseNote, SaveReleaseNote$Request>>('RELEASE_NOTES_CONTROLLER__SAVE_RELEASE_NOTE__SUCCESS');
export const saveReleaseNoteFailure = createAction<PayloadData<Error, SaveReleaseNote$Request, true>>('RELEASE_NOTES_CONTROLLER__SAVE_RELEASE_NOTE__FAILURE');

export const saveReleaseNoteActions = [
    saveReleaseNoteRequest,
    saveReleaseNoteSuccess,
    saveReleaseNoteFailure
] as const;

/**
 * Save Release Note
 * @param {ReleaseNote} meta.releaseNote
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveReleaseNote = (meta: SaveReleaseNote$Request, config?: SaveReleaseNote$Config) => {
    return {
        CALL_API: {
            types: saveReleaseNoteActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/api-v2/release-notes`,
            TRANSPORT_REQUEST_BODY: meta.releaseNote,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateReleaseNote$Request {
    releaseNote: ReleaseNote;
}

export interface UpdateReleaseNote$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateReleaseNoteRequest = createAction<PayloadData<void, UpdateReleaseNote$Request>>('RELEASE_NOTES_CONTROLLER__UPDATE_RELEASE_NOTE__REQUEST');
export const updateReleaseNoteSuccess = createAction<PayloadData<ReleaseNote, UpdateReleaseNote$Request>>('RELEASE_NOTES_CONTROLLER__UPDATE_RELEASE_NOTE__SUCCESS');
export const updateReleaseNoteFailure = createAction<PayloadData<Error, UpdateReleaseNote$Request, true>>('RELEASE_NOTES_CONTROLLER__UPDATE_RELEASE_NOTE__FAILURE');

export const updateReleaseNoteActions = [
    updateReleaseNoteRequest,
    updateReleaseNoteSuccess,
    updateReleaseNoteFailure
] as const;

/**
 * Update Release Note
 * @param {ReleaseNote} meta.releaseNote
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateReleaseNote = (meta: UpdateReleaseNote$Request, config?: UpdateReleaseNote$Config) => {
    return {
        CALL_API: {
            types: updateReleaseNoteActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/api-v2/release-notes`,
            TRANSPORT_REQUEST_BODY: meta.releaseNote,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

